



























































import {Component, Vue} from 'vue-property-decorator';
import {State, Getter, Action, Mutation} from 'vuex-class';

@Component({
  components: {},
})
export default class Download extends Vue {
  @Getter('deviceName')
  private deviceName!: any;

  private resolveDialogVisible: boolean = false;
  private isWeixinTip: boolean = false;
  private isWeixin: boolean = false;

  private created() {
    document.title = 'App下载页-目的地桩';
    this.isWeixin = (() => {
      return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
    })();
  }

  private resolveOpen() {
    this.resolveDialogVisible = true;
  }

  private resolveClose() {
    this.resolveDialogVisible = false;
  }

  private downloadClick() {
    if (this.isWeixin) {
      this.isWeixinTip = true;
    } else {
      this.isWeixinTip = false;
    }
  }
}
